import { useCallback, useMemo } from 'react';
import { useEditorStateContext } from '../../context/notes/notes_editor_state_context';
export function useEditButton() {
    const { setDisplayModeYn, inCallOrPostCall, captureButtonClick, readOnlyYn } = useEditorStateContext();
    const onClick = useCallback(() => {
        setDisplayModeYn(false);
        typeof captureButtonClick === 'function' &&
            captureButtonClick(`${inCallOrPostCall}-notes-edit-button`);
    }, [captureButtonClick, inCallOrPostCall, setDisplayModeYn]);
    return useMemo(() => ({
        onClick,
        readOnlyYn,
    }), [onClick, readOnlyYn]);
}
//# sourceMappingURL=use_edit_button.js.map